import React from "react";
import { AccordionItem, Box, Divider } from "@chakra-ui/react";
import type { IContentHeader } from "../../..";
import MenuButton from "../MenuButton";
import MenuSubItem from "../MenuSubItem";
import { observer } from "mobx-react-lite";

const MenuItem: React.FC<IContentHeader> = observer(({ menu, subMenu, onTriggerTagging, setIsOpen }) => (
	<AccordionItem border={"none"} mt={0}>
		{({ isExpanded }) => (
			<>
				<MenuButton menu={menu} subMenu={subMenu} onTriggerTagging={onTriggerTagging} isSubMenuOpen={isExpanded}/>
				<Box m={"0 16px"}>
					<Divider borderColor={"white.200"} opacity={1} />
				</Box>
				{isExpanded && <MenuSubItem subMenu={subMenu} menuTitle={menu.label} setIsOpen={setIsOpen} onTriggerTagging={onTriggerTagging} />}
			</>
		)}
	</AccordionItem>
));

export default MenuItem;
